/* eslint-disable no-plusplus */
/* eslint-disable space-before-function-paren */
/* eslint-disable func-names */
import EDC from './globals';

EDC.UI.Timer = function(scene) {
  this.scene = scene;
  this.timer = null;
  this.overallSeconds = 0;
  this.container = null;
  this.timeText = null;
  this.width = 200;
  this.height = 100;
  return this;
};
/**
 *
 */
EDC.UI.Timer.prototype.create = function() {
  this.container = this.scene.add.container(10, 970);
  this.container.setSize(this.width, this.height);
  this.createBackground();
  this.createTimeText();
  this.timer = this.scene.time.addEvent(
    {
      delay: 1000,
      callback: this.update,
      callbackScope: this,
      loop: true,
    },
  );
  return this;
};
/**
 *
 */
EDC.UI.Timer.prototype.update = function() {
  this.overallSeconds++;
  const minutes = this.getMinutes();
  if (minutes > 99) {
    this.overallSeconds = 0;
  }
  const str = this.getTimeString();
  this.timeText.setText(str);
};
/**
 *
 */
EDC.UI.Timer.prototype.getTime = function() {

};
/**
 *
 */
EDC.UI.Timer.prototype.createTimeText = function() {
  this.timeText = this.scene.add.text(0, 0, '00:00', {
    fontFamily: 'Arial',
    fontSize: '50pt',
    fontStyle: 'bold',
    align: 'center',
    color: 'white',
  });

  // eslint-disable-next-line max-len
  this.timeText.setPosition(this.width / 2 - this.timeText.width / 2, this.height / 2 - this.timeText.height / 2);
  this.container.add(this.timeText);
};
/**
 *
 */
EDC.UI.Timer.prototype.pause = function() {
  this.timer.paused = true;
};
/**
 *
 */
EDC.UI.Timer.prototype.resume = function() {
  this.timer.paused = false;
};
/**
 *
 */
EDC.UI.Timer.prototype.getSeconds = function() {
  return this.overallSeconds % 60;
};
/**
 *
 */
EDC.UI.Timer.prototype.getOverallSeconds = function() {
  return this.overallSeconds;
};
/**
 *
 */
EDC.UI.Timer.prototype.getMinutes = function() {
  return Math.floor(this.overallSeconds / 60);
};
/**
 *
 */
EDC.UI.Timer.prototype.createBackground = function() {
  const g = this.scene.add.graphics();
  g.fillStyle(0x000000, 0.5);
  g.fillRoundedRect(0, 0, this.width, this.height, 25);
  this.container.add(g);
};
/**
 *
 */

EDC.UI.Timer.prototype.getTimeString = function() {
  const minutes = this.getMinutes();
  const seconds = this.getSeconds();
  let minutesStr = '';
  let secondsStr = '';
  minutesStr = minutes < 10 ? `0${minutes}` : minutes;
  secondsStr = seconds < 10 ? `0${seconds}` : seconds;
  return `${minutesStr}:${secondsStr}`;
};

export default EDC.UI.Timer;
